import { NotifyHelper } from "../../../helpers/toast";
import { eChuongTrinhDaoTaoRangBuocActionsObj } from "../../action-types/ctdt/IChuongTrinhDaoTaoRangBuocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const chuongTrinhDaoTaoRangBuocActions = {
    ...generateActions(eChuongTrinhDaoTaoRangBuocActionsObj, "CHUONG_TRINH_DAO_TAO_RANG_BUOC"),
    ...generateActionForKey(eChuongTrinhDaoTaoRangBuocActionsObj, "CHUONG_TRINH_DAO_TAO_RANG_BUOC",
        "SAVE_MULTIPLE_SUCCESS", () => { NotifyHelper.Success("Thành công") }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoRangBuocActionsObj, "CHUONG_TRINH_DAO_TAO_RANG_BUOC",
        "SAVE_MULTIPLE_ERROR", (m) => { NotifyHelper.Error(m) }
    ),
}